/**
 * Normalize LLM markdown quirks in speaking feedback strings.
 * Common issue: "**Title**:** explanation" instead of "**Title**: explanation".
 */
export const sanitizeSpeakingFeedbackMarkdown = (text) => {
  if (typeof text !== 'string') {
    return text;
  }

  let cleaned = text.trim();
  if (!cleaned) {
    return cleaned;
  }

  // **Title**:** -> **Title**:
  cleaned = cleaned.replace(/\*\*([^*]+?)\*\*\*\*:/g, '**$1**:');

  // **Title** :** or **Title**: ** -> **Title**:
  cleaned = cleaned.replace(/\*\*([^*]+?)\*\*\s*:\s*\*\*/g, '**$1**:');

  // **Title****: -> **Title**:
  cleaned = cleaned.replace(/\*\*([^*]+?)\*\*{3,}:/g, '**$1**:');

  return cleaned;
};
